export const FilterTypes = Object.freeze({
  AUTOCOMPLETE_SINGLE: "autocompleteSingle",
  CHECKBOX: "checkbox",
  COLOR_INPUT: "colorInput",
  DATERANGE_PICKER: "daterangePicker",
  DROPDOWN_MULTI: "dropdownMulti",
  DROPDOWN_SINGLE: "dropdownSingle",
  INPUT: "input",
  MONTH_RANGES_MULTI: "monthRangesMulti",
  NUMERIC_RANGE_PICKER: "numericRangePicker",
  RADIO: "radio",
  SWITCH: "switch",
  TIME_PICKER: "timePicker",
});

export type FilterType = (typeof FilterTypes)[keyof typeof FilterTypes];
